import { render, staticRenderFns } from "./ActivityAssigmentList.vue?vue&type=template&id=5bb4a138&scoped=true"
import script from "./ActivityAssigmentList.vue?vue&type=script&lang=ts"
export * from "./ActivityAssigmentList.vue?vue&type=script&lang=ts"
import style0 from "./ActivityAssigmentList.vue?vue&type=style&index=0&id=5bb4a138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb4a138",
  null
  
)

export default component.exports